
import React from 'react'
import Counter from "../Common/Counter"

const Stats = () => {
  return (
    <section className='flex sm:flex-col  sm:w-full bg-[#4C429F] py-7 justify-between w-full  mx-auto mt-0 mb-24'>
        <div className='stat-br sm:w-[80%] sm:py-5 sm:mx-auto w-full text-center'>
       <Counter end={3000} icon={"+"} />
            <p className='text-[#fff] text-base md:text-[13px] font-normal mt-3'>Enrolled Students</p>
        </div>
        <div className='stat-br sm:w-[80%] sm:py-5 sm:mx-auto w-full text-center'>
        <Counter end={40} icon={"+"} />
            <p className='text-[#fff] text-base md:text-[13px] font-normal mt-3'>Experienced Teachers</p>
        </div>
        <div className='stat-br sm:w-[80%] sm:py-5 sm:mx-auto w-full text-center'>
        <Counter end={30} icon={"+"} />
            <p className='text-[#fff] text-base md:text-[13px] font-normal mt-3'>Taught Subjects</p>
        </div>
        <div className='w-full sm:w-[80%] sm:py-5 sm:mx-auto text-center'>
        <Counter end={2000} icon={"+"} />
            <p className='text-[#fff] text-base md:text-[13px] font-normal mt-3'>Success Stories</p>
        </div>
    </section>
  )
}

export default Stats